export default {
	common: {
		appTitle: 'Soft AI',
		loading: 'Wird geladen…',
		loadMore: 'Mehr laden',
	},

	language: {
		title: 'Sprache',
		subtitle: 'Wähle deine bevorzugte Sprache',
		description:
			'Oberfläche, Menüs und Charakterbeschreibungen werden in der gewählten Sprache angezeigt. Du kannst sie jederzeit ändern.',
		selectLanguage: 'Sprache auswählen',
		active: 'Aktiv',
		pl: 'Polski',
		plDescription: 'Polnische Oberfläche und Inhalte',
		de: 'Deutsch',
		deDescription: 'Deutsche Oberfläche und Inhalte',
		en: 'English',
		enDescription: 'Englische Oberfläche und Inhalte',
		cs: 'Čeština',
		csDescription: 'Tschechische Oberfläche und Inhalte',
		close: 'Schließen',
	},

	login: {
		title: 'Soft AI',
		subtitle: 'Finde deinen perfekten Begleiter.',
		subtitleLogin: 'Gib dein Passwort ein, um fortzufahren.',
		subtitleSetPassword:
			'Dein Konto existiert bereits. Lege ein Passwort fest, um dich anzumelden.',
		subtitleRegister: 'Erstelle dein Konto, um loszulegen.',
		emailLabel: 'E-Mail-Adresse',
		emailPlaceholder: 'E-Mail eingeben',
		passwordLabel: 'Passwort',
		passwordPlaceholder: '••••••••',
		passwordSetPlaceholder: 'Passwort erstellen',
		passwordLabelRegister: 'Passwort festlegen',
		confirmPasswordLabel: 'Passwort bestätigen',
		confirmPasswordPlaceholder: 'Passwort bestätigen',
		loginButton: 'Anmelden',
		loggingIn: 'Anmeldung...',
		checkingEmail: 'E-Mail wird geprüft...',
		registering: 'Konto wird erstellt...',
		loginSuccessButton: 'Angemeldet',
		registerSuccessButton: 'Konto erstellt',
		continueButton: 'Weiter',
		registerButton: 'Registrieren',
		setPasswordButton: 'Passwort festlegen',
		forgotPasswordLink: 'Passwort vergessen?',
		registerLink: 'Registrieren',
		goBackLink: 'E-Mail ändern',
		resetPasswordLink: 'Passwort zurücksetzen',
		resetModalTitle: 'Passwort zurücksetzen',
		resetModalHint:
			'Gib deine E-Mail ein und wir senden dir einen Link zum Zurücksetzen deines Passworts.',
		sendResetLinkButton: 'Link zum Zurücksetzen senden',
		resetSending: 'Wird gesendet...',
		resetBackToLogin: 'Zurück zur Anmeldung',
		resetSuccessTitle: 'E-Mail prüfen',
		resetSuccessHint: 'Wir haben dir einen Link zum Zurücksetzen gesendet.',
		resetSuccessMessage:
			'Wenn ein Konto mit dieser E-Mail existiert, erhältst du in Kürze einen Link. Prüfe auch den Spam-Ordner.',
		passwordMismatch: 'Passwörter stimmen nicht überein.',
		passwordRequirements: 'Mindestens 6 Zeichen.',
		passwordTooShort: 'Das Passwort muss mindestens 6 Zeichen lang sein.',
		passwordNeedsNumber: 'Das Passwort muss mindestens eine Zahl enthalten.',
		passwordNeedsSpecial:
			'Das Passwort muss mindestens ein Sonderzeichen enthalten.',
		errorMessage:
			'Ungültige E-Mail-Adresse oder Passwort. Bitte versuche es erneut.',
		invalidCredentials: 'Ungültige Anmeldedaten',
		registerFailed:
			'Prüfe deine E-Mail — ein Konto wurde möglicherweise bereits erstellt.',
		showPassword: 'Passwort anzeigen',
		hidePassword: 'Passwort verbergen',
	},

	restartPassword: {
		statusLoading: 'Prüfung',
		statusReady: 'Reset',
		statusSuccess: 'Fertig',
		statusInvalid: 'Abgelaufen',
		loadingTitle: 'Link wird geprüft',
		loadingMessage: 'Bitte warte, während wir deinen Reset-Link prüfen.',
		invalidTitle: 'Dieser Link ist ungültig',
		invalidMessage:
			'Der Link ist abgelaufen oder wurde bereits verwendet. Fordere einen neuen über den Login an.',
		successTitle: 'Passwort aktualisiert',
		successMessage:
			'Dein neues Passwort ist bereit. Du kannst dich jetzt bei Soft AI anmelden.',
		formTitle: 'Neues Passwort festlegen',
		formMessage:
			'Wähle ein neues Passwort für dein Konto. Der Link ist 24 Stunden gültig.',
		passwordLabel: 'Neues Passwort',
		passwordPlaceholder: 'Neues Passwort eingeben',
		confirmPasswordLabel: 'Passwort bestätigen',
		confirmPasswordPlaceholder: 'Neues Passwort wiederholen',
		passwordRequirements: 'Mindestens 6 Zeichen.',
		passwordResetTooShort: 'Das Passwort muss mindestens 6 Zeichen haben.',
		passwordMismatch: 'Passwörter stimmen nicht überein.',
		submitButton: 'Neues Passwort speichern',
		submitting: 'Speichern...',
		backToApp: 'Zurück zu Soft AI',
		showPassword: 'Passwort anzeigen',
		hidePassword: 'Passwort verbergen',
		errorGeneric: 'Passwort konnte nicht geändert werden. Versuche es erneut.',
	},

	studio: {
		createTitlePrefix: 'Erstelle deine',
		createTitleHighlight: 'Softie',
		navigation: 'Studio-Navigation',
		back: 'Zurück',
		next: 'Weiter',
		createSoftie: 'Softie erstellen',
		chooseGender: 'Geschlecht wählen',
		chooseEthnicity: 'Ethnizität wählen',
		chooseHairstyle: 'Frisur wählen',
		chooseHairColor: 'Haarfarbe wählen',
		chooseBodyType: 'Körpertyp wählen',
		chooseEyeColor: 'Augenfarbe wählen',
		chooseBreastSize: 'Brustgröße wählen',
		chooseBulgeSize: 'Größe wählen',
		chooseAge: 'Alter wählen',
		confirmAge: 'Bestätigen',
		ageLabel: 'Alter',
		yearsOld: 'Jahre alt',
		finalTitle: 'Mach deinen Softie wirklich zu deinem',
		generatingTitle: 'Charakter wird generiert',
		creatingSoftie: 'Deine Softie entsteht',
		generatingHint:
			'Wir verbinden Aussehen, Stimmung und Stimme zu einer Persona.',
		generatingPhaseLook: 'Aussehen formen',
		generatingPhasePersona: 'Persönlichkeit weben',
		generatingPhaseAwaken: 'Erwecken',
		generatingPhoto: 'Foto wird generiert...',
		estimatedPhotoTimeRemaining: 'Geschätzte Zeit: {seconds}s',
		estimatedVideoTimeRemaining: 'Fast fertig: {seconds}s',
		resultTitle: 'Dein Softie wartet',
		awakenSoftie: 'Softie erwecken',
		meetMySoftie: 'Lerne deine Softie kennen',
		rerollLook: 'Aussehen neu würfeln',
		name: 'Name',
		fieldEthnicity: 'Ethnizität',
		fieldAge: 'Alter',
		fieldEyeColor: 'Augenfarbe',
		fieldBodyType: 'Körpertyp',
		fieldHairstyle: 'Frisur',
		fieldHairColor: 'Haarfarbe',
		fieldBreastSize: 'Brustgröße',
		fieldBulgeSize: 'Größe',
		personality: 'Persönlichkeit',
		occupation: 'Beruf',
		relationship: 'Beziehung',
		nationality: 'Nationalität',
		city: 'Stadt',
		zodiac: 'Sternzeichen',
		kinks: 'Vorlieben',
		voice: 'Stimme',
		confirmFinal: 'Bestätigen',
		namePlaceholder: 'Charaktername',
		cityPlaceholder: 'Stadt',
		done: 'Fertig',
		gridOptionLabels: {},
		gender: {
			chooseGender: 'Geschlecht wählen',
			woman: 'Frau',
			men: 'Mann',
			trans: 'Trans',
		},
	},

	imageGeneration: {
		title: 'KI-Charaktergenerator',
		subtitle:
			'Erwecke deine Fantasie zum Leben: Wähle jedes Detail, vom Blick bis zum Outfit.',
		characterName: 'Charaktername',
		characterNamePlaceholder: 'z. B. Alexandra, Zoja, Carmen...',
		prompt: 'Prompt',
		promptPlaceholder:
			'z. B. Blondine in rotem Kleid vor dem Hintergrund einer Nachtstadt...',
		randomPrompt:
			'Nicht sicher, was du schreiben sollst? Klicke, um eine Beschreibung zu generieren!',
		customization: 'Charakteranpassung',
		numberOfImages: 'Anzahl der zu generierenden Bilder',
		imageCount: '{count} Bild',
		imagesCount: '{count} Bilder',
		generating: 'Wird generiert...',
		generateCharacter: 'Charakter generieren',
		historyTitle: 'Verlauf generierter Charaktere',
		loading: 'Wird geladen...',
		emojiIconAlt: 'Emoji-Symbol',
	},

	nav: {
		mainNavigation: 'Hauptnavigation',
		lounge: 'Lounge',
		discover: 'Entdecken',
		chat: 'Chat',
		studio: 'Studio',
		mySofties: 'Meine Softies',
	},

	topBar: {
		sparkBalance: 'Spark-Guthaben',
		openSparkPackages: 'Spark-Pakete öffnen',
		totalBalance: 'Gesamtguthaben',
		account: 'Konto',
		logIn: 'Anmelden',
		register: 'Registrieren',
	},

	authModal: {
		loginTitle: 'Anmelden',
		registerTitle: 'Konto erstellen',
		brandKicker: 'Deine Fantasie',
		brandHeadline: 'Ohne Limits',
		brandTagline: 'Tritt ein in die Welt deiner tiefsten Sehnsüchte.',
		loginHint:
			'Willkommen zurück. Melde dich an, um mit deinen Softies zu chatten.',
		registerHint:
			'Erstelle ein kostenloses Konto, um den Chat freizuschalten und deine Begleiter zu speichern.',
		visualTitle: 'Triff deine Softies',
		visualDescription:
			'Erstelle Begleiter, entdecke Styles und schalte den Chat mit einem kostenlosen Konto frei.',
		loginVisualTitle: 'Willkommen zurück',
		loginVisualDescription:
			'Melde dich an und mach da weiter, wo du mit deinen Softies aufgehört hast.',
		guestBrowseHint:
			'Stöbere kostenlos durch Charaktere. Melde dich an oder registriere dich, um zu chatten, Softies zu erstellen und vollen Zugang freizuschalten.',
		hasAccountPrompt: 'Du hast bereits ein Konto?',
		switchToLogin: 'Anmelden',
		noAccountPrompt: 'Noch kein Konto?',
		switchToRegister: 'Registrieren',
		loginAction: 'Anmelden',
		registerAction: 'Registrieren',
		continueBrowsing: 'Weiter stöbern',
		tabSwitcherLabel: 'Anmeldemodus',
		close: 'Schließen',
	},

	ageGate: {
		badge: '18+',
		title: 'Nur für Erwachsene',
		message:
			'Soft AI ist nur für Nutzer ab 18 Jahren. Bitte bestätige, dass du mindestens 18 Jahre alt bist, um fortzufahren.',
		confirm: 'Ich bin 18 oder älter',
		decline: 'Ich bin unter 18',
		blockedTitle: 'Zugang gesperrt',
		blockedMessage:
			'Du musst mindestens 18 Jahre alt sein, um Soft AI zu nutzen. Du kannst diese Seite jetzt verlassen.',
		legalPrefix:
			'Indem du fortfährst, bestätigst du, dass du über 18 Jahre alt bist und unseren',
		termsOfService: 'Nutzungsbedingungen',
		legalAnd: 'und der',
		privacyPolicy: 'Datenschutzrichtlinie',
	},

	cookieConsent: {
		ariaLabel: 'Cookie-Einwilligung',
		title: 'Diese Website verwendet Cookies',
		description:
			'Wir verwenden Cookies, um unsere Dienste bereitzustellen und zu verbessern, die Nutzung zu analysieren und dein Erlebnis zu personalisieren.',
		readMore: 'Mehr erfahren',
		necessary: 'Notwendig',
		necessaryDescription:
			'Erforderlich für Sicherheit, Anmeldung und grundlegende Funktionen. Immer aktiv und können nicht deaktiviert werden.',
		analytics: 'Analyse',
		analyticsDescription:
			'Erfassen anonyme Nutzungsdaten, damit wir Leistung und Inhalte verbessern können. Nur mit deiner Einwilligung.',
		marketing: 'Marketing',
		marketingDescription:
			'Ermöglichen personalisierte Werbung und Kampagnenmessung, auch durch unsere Partner. Nur mit deiner Einwilligung.',
		preferences: 'Präferenzen',
		preferencesDescription:
			'Speichern deine Einstellungen (z. B. Sprache oder Darstellung) für ein komfortableres Erlebnis. Nur mit deiner Einwilligung.',
		acceptAll: 'Alle akzeptieren',
		customize: 'Anpassen',
		saveSelected: 'Auswahl speichern',
		rejectAll: 'Alle ablehnen',
	},



	sparkModal: {
		premiumAccess: 'Premium-Zugang',
		premiumDescription:
			'Lade Sparks auf, um Bilder, Videos und einzigartige Momente ohne Wartezeit zu generieren.',
		closeSparkPackages: 'Spark-Pakete schließen',
		selectPackage: 'Paket auswählen',
		usageTitle: 'So werden Sparks verwendet:',
		messageUsage: 'Nachricht:',
		messageUsageValue: '0 Sparks',
		voiceUsage: 'Stimme:',
		voiceUsageValue: '0 Sparks',
		photoUsage: 'Foto:',
		photoUsageValue: '5 Sparks',
		videoUsage: 'Video:',
		videoUsageValue: '50 Sparks',
		characterUsage: 'Charaktererstellung:',
		characterUsageValue: '100 Sparks',
		sparkPackages: 'Spark-Pakete',
		termsOfService: 'Nutzungsbedingungen',
		privacyPolicy: 'Datenschutzrichtlinie',
		acceptTermsPrefix: 'Ich akzeptiere die',
		acceptTermsAnd: 'und',
		selectPackageButton: 'Paket auswählen',
		continueWithPrice: 'Weiter ({price})',
		packages: {
			basic: {
				name: 'BASIC',
				sparks: '1000 Sparks',
			},
			pro: {
				name: 'PRO',
				sparks: '3000 Sparks',
			},
			premium: {
				name: 'PREMIUM',
				sparks: '6000 Sparks',
			},
		},
	},

	profileAccount: {
		account: 'Konto',
		displayName: 'Anzeigename',
		nameRequired: 'Anzeigename ist erforderlich.',
		nameSaveError:
			'Anzeigename konnte nicht gespeichert werden. Bitte versuche es erneut.',
		tokens: 'Tokens',
		planValidUntil: 'Plan gültig bis',
		memberSince: 'Mitglied seit:',
		support: 'Support: support@softai.today',
		supportLabel: 'Support',
		supportEmail: 'support@softai.today',
		logOut: 'Abmelden',
		loggingOut: 'Abmeldung...',
		privacyPolicy: 'Datenschutzrichtlinie',
		termsOfUse: 'Nutzungsbedingungen',
	},

	home: {
		stories: 'Stories',
		previousStories: 'Vorherige Stories',
		nextStories: 'Nächste Stories',
		storyClose: 'Story schließen',
		storyPrev: 'Vorherige Story',
		storyNext: 'Nächste Story',
		storyPlay: 'Abspielen',
		storyPause: 'Pause',
		storyTimeAgo: '5h',
		storyReplyPlaceholder: 'Nachricht schreiben...',
		storyReplySend: 'Senden',
		loungeHighlight: 'Lounge-Highlight',
		loungeTitlePrefix: 'Wähle deine',
		loungeTitleSoftie: 'Softie',
		loungeTitleMiddle: ', folge dem',
		loungeTitleVibe: 'Vibe',
		surpriseMe: 'Überrasche mich',
		loungeCategories: 'Lounge-Kategorien',
		previousCategories: 'Vorherige Kategorien',
		nextCategories: 'Nächste Kategorien',
		categoriesLabel: 'Kategorien',
		all: 'Alle',
		loadingTags: 'Tags werden geladen…',
		categories: {
			Neighbor: 'Nachbarin',
			Romantic: 'Romantisch',
			Sweet: 'Süß',
			Naughty: 'Frech',
			Mature: 'Reif',
			Luxury: 'Luxuriös',
			Fitness: 'Fitness',
			Bossy: 'Dominant',
			Nerdy: 'Nerdy',
			Trans: 'Trans',
			Mystic: 'Mystisch',
			Fantasy: 'Fantasy',
			Men: 'Männer',
		},
	},

	discover: {
		ariaLabel: 'Charaktere entdecken',
		back: 'Zurück zur Lounge',
		swipeHint: 'Nach oben für mehr',
		loadingProfiles: 'Charaktere werden geladen...',
	},

	mySofties: {
		titlePrefix: 'Meine',
		titleHighlight: 'Softies',
		createSoftie: 'Erstelle deine Softie',
	},

	profileModal: {
		close: 'Profil schließen',
		characterGallery: 'Charaktergalerie',
		previousPhoto: 'Vorheriges Foto',
		nextPhoto: 'Nächstes Foto',
		photoNumber: 'Foto {number}',
		startChatting: 'Chat starten',
		meta: '{age} · {origin}',
		defaultOrigin: 'Unbekannt',
		personalityAttributes: 'Persönlichkeitsmerkmale',
		physicalAttributes: 'Körperliche Merkmale',
		occupation: 'Beruf',
		relationship: 'Beziehung',
		kinks: 'Vorlieben',
		ethnicity: 'Ethnizität',
		country: 'Land',
		age: 'Alter',
		bodyType: 'Körpertyp',
		zodiacSign: 'Sternzeichen',
		unknown: 'Unbekannt',
		defaultOccupation: 'Begleiter',
		defaultRelationship: 'Single',
		defaultZodiac: 'Waage',
		defaultKinks: 'Necken',
	},

	profileCard: {
		portraitAlt: 'Porträt von {name}',
		regenerateImage: 'Bild neu generieren',
	},

	chat: {
		conversationPanel: 'Gesprächsbereich',
		companionProfile: 'Begleiterprofil',
		loadingTitle: 'Gespräch wird geladen...',
		loadingText:
			'Benutzer- und Chat-Daten werden abgerufen. Bitte warte einen Moment.',
		noConversationTitle: 'Kein Gespräch ausgewählt',
		noConversationText:
			'Wähle ein bestehendes Gespräch aus der Liste oder starte ein neues, um zu chatten.',
		online: 'Online',
		back: 'Zurück',
		generatingImage: 'Bild wird generiert...',
		generatingVideo: 'Video wird vorbereitet...',
		estimatedTimeRemaining: 'Geschätzte verbleibende Zeit: {seconds}s',
		estimatedTextTimeRemaining: 'Geschätzte Zeit: {seconds}s',
		estimatedVideoTimeRemaining: 'Fast fertig: {seconds}s',
		writeMessage: 'Nachricht schreiben...',
		sendMessage: 'Nachricht senden',
		sendMePhoto: 'Schick mir ein Foto',
		sendMeVideo: 'Schick mir ein Video',
		call: 'Anrufen',
		endCall: 'Anruf beenden',
		callInProgress: 'Anruf läuft',
		viewLevelScore: 'Gesprächsstufe und Score anzeigen',
		viewConversationTemperature: 'Gesprächstemperatur — Details öffnen',
		conversationTemperature: 'Gesprächstemperatur',
		temperatureSubtitle:
			'Je besser ihr euch kennt, desto mutiger wird deine Softie.',
		levelScoreTitle: 'Gesprächsstufe',
		levelNumberLabel: 'Stufe {number} · {name}',
		progressToNextLevel: '{percent}% bis {name}',
		maxLevelLabel: 'Maximale Stufe',
		whatRaisesTemperature: 'Was heizt die Temperatur an?',
		levelUpTitle: 'Es wird heißer',
		newLevelEyebrow: 'Neue Stufe',
		continueConversation: 'Weiter chatten',
		levelOfMax: 'Stufe {current} von {max}',
		nextLevelLabel: 'Nächste Stufe',
		scoreEmptyState: 'Schreib weiter, um deinen Score aufzubauen.',
		pointsLabel: 'Pkt',
		remainingPercentLabel: 'Verbleibend',
		scoreChartTitle: 'Punktediagramm',
		scoreCategoriesTitle: 'Kategoriewerte',
		close: 'Schließen',
		scoreDimensions: {
			effort: 'Engagement',
			flirt: 'Flirt',
			concreteness: 'Konkretheit',
			politeness: 'Höflichkeit',
		},
		voiceCallActive: 'Sprachanruf aktiv',
		voiceCallStartSpeaking: 'Fang an zu sprechen...',
		voiceCallSpeaking: 'Sie spricht...',
		voiceCallYouSpeaking: 'Du sprichst...',
		voiceCallProcessing: 'Antwort wird verbunden...',
		callMessage: 'Hey, bist du da?',
		videoReply: 'Klar, hier ist dein Video.',
		videoNotAvailable: 'Video ist für diesen Begleiter noch nicht verfügbar.',
		fetchMessagesError:
			'Beim Laden der Nachrichten ist etwas schiefgelaufen. Bitte versuche es erneut.',
		illegalContentError:
			'Diese Art von Nachricht ist im Chat nicht erlaubt. Deine Nachricht wurde entfernt.',
		noTokensError: 'Keine Sparks mehr! Lade auf, um weiterzumachen.',
		imageGenerationError:
			'Vorübergehende technische Probleme. Bitte versuche es später erneut.',
		videoGenerationError:
			'Vorübergehende technische Probleme. Bitte versuche es später erneut.',
		guestGateTitle: 'Registriere dich, um zu chatten',
		guestGateDescription:
			'Erstelle ein Konto, wähle einen Plan und starte in wenigen Minuten mit deiner Softie.',
		guestGateHeroTitle: 'Dein Softie wartet',
		guestGateHeroDescription:
			'Registriere dich, um Chat, Fotos und personalisierte Momente freizuschalten.',
		guestGateRegister: 'Registrieren',
		guestGateLogin: 'Ich habe bereits ein Konto',
		planPaywallTitle: 'Wähle deinen Plan',
		planPaywallDescription: 'Voller Zugang zu Chat und Content-Erstellung.',
		planPaywallBenefitUncensored: 'Gespräche ohne Zensur und Einschränkungen',
		planPaywallBenefitPrivatePhotos: 'Exklusive private Fotos',
		planPaywallBenefitPriorityAi: 'Priorisierte KI-Verarbeitung',
		planPaywallHeroTitle: 'Premium-Zugang',
		planDurationBasic: '1 Monat voller Zugang',
		planDurationPro: '3 Monate voller Zugang',
		planDurationPremium: '6 Monate voller Zugang',
		planPaywallSelectPlan: 'Plan auswählen',
		planPaywallContinue: 'Weiter ({price})',
		planPaywallPopular: 'Beliebt',
		planCheckoutSectionEyebrow: 'Kasse',
		planCheckoutSectionTitle: 'Zahlungsdetails',
		planCheckoutSectionSubtitle: 'Wähle eine Methode und schließe den Kauf ab',
		planCheckoutSelectedPlan: 'Gewählter Plan',
		planCheckoutClose: 'Planwahl schließen',
		planCheckoutCompleteTitle: 'Checkout abschließen',
		planCheckoutOneOffSubtitle: 'Sichere Zahlung über Stripe.',
		planCheckoutSubscriptionSubtitle:
			'Sicheres Monatsabo über Stripe. Gib unten deine Kartendaten ein.',
		planCheckoutRecurring: 'Wiederkehrende Abrechnung • Jederzeit kündbar',
		planCheckoutProcessing: 'Wird verarbeitet...',
		planCheckoutCreatingSubscription: 'Abonnement wird erstellt...',
		orderStatusVerifyingPayment: 'Zahlung wird überprüft...',
		orderStatusPillVerifying: 'Prüfung',
		orderStatusPillSuccess: 'Erfolg',
		orderStatusPillFailed: 'Fehler',
		orderStatusRedirecting: 'Gleich weiterleiten...',
		orderStatusVerifyingPaymentDescription:
			'Wir bestätigen deine Zahlung. Das kann bis zu 2 Minuten dauern.',
		orderStatusPaymentSuccess: 'Plan bezahlt!',
		orderStatusPaymentSuccessDescription:
			'Dein Abonnement ist aktiv. Du wirst gleich weitergeleitet.',
		orderStatusTokensSuccess: 'Sparks aufgeladen!',
		orderStatusTokensSuccessDescription:
			'Zahlung bestätigt. Du wirst gleich zurückgeleitet.',
		orderStatusPaymentFailed: 'Zahlung fehlgeschlagen',
		orderStatusPaymentFailedDescription:
			'Die Zahlung konnte nicht bestätigt werden. Bitte versuche es erneut oder kontaktiere den Support.',
		orderStatusPaymentTimeout:
			'Die Zahlung konnte innerhalb von 2 Minuten nicht bestätigt werden. Bitte versuche es erneut.',
		orderStatusBackToCheckout: 'Zurück zur Zahlung',
		orderStatusGoToLogin: 'Zum Login',
		planCheckoutSubscribe: 'Abonnieren ({price})',
		planCheckoutPaymentLabel: 'Zahlungsmethode',
		planCheckoutCardLabel: 'Kartendaten',
		planCheckoutSubscribeTermsPrefix: 'Mit dem Abonnement stimmst du unseren',
		planCheckoutPay: 'Zahle {price}',
		planCheckoutTermsPrefix: 'Mit dem Kauf stimmst du unseren',
		planCheckoutTermsLink: 'Nutzungsbedingungen',
		planCheckoutTermsAnd: 'und der',
		planCheckoutPrivacyLink: 'Datenschutzerklärung',
		planCheckoutSecureStripe: 'Stripe · verschlüsselt · sicher',
		planCheckoutBadge: 'Premium',
		planCheckoutLoadingPayment: 'Zahlungsformular wird geladen...',
		planCheckoutPaymentError:
			'Zahlung konnte nicht gestartet werden. Bitte erneut versuchen.',
		planCheckoutStripeMissing:
			'Stripe Public Key fehlt (VITE_STRIPE_PUBLIC_KEY).',
		planCheckoutLoginRequired: 'Melde dich an, um den Plan zu bezahlen.',
		tokensExhaustedTitle: 'Deine Sparks sind aufgebraucht',
		tokensExhaustedDescription:
			'Lade Sparks auf, um weiter zu chatten und neue Inhalte zu generieren.',
		tokensExhaustedHeroTitle: 'Sparks aufladen',
		tokensExhaustedHeroDescription:
			'Wähle ein Spark-Paket und kehre ohne Unterbrechung zum Chat zurück.',
		generatedImageAlt: 'Generiertes Bild',
		generatedVideoAlt: 'Generiertes Video',
		videoLoadError:
			'Video konnte nicht geladen werden. Bitte aktualisiere die Seite und versuche es erneut.',
		feedbackActionsLabel: 'Feedback',
		feedbackLikeTitle: 'Was hat dir an dieser Antwort gefallen?',
		feedbackDislikeTitle: 'Was sollten wir verbessern?',
		feedbackDislikePlaceholder:
			'Erforderlich: Beschreibe das Problem (min. 5 Zeichen)',
		feedbackOptionalPlaceholder: 'Dein Feedback (optional)',
		feedbackSkip: 'Überspringen',
		feedbackSubmit: 'Absenden',
		feedbackSending: 'Wird gesendet...',
		feedbackMinLengthHint:
			'Schreibe eine Nachricht (min. 5 Zeichen) oder drücke „Überspringen", um Feedback ohne Text zu senden.',
		feedbackHint:
			'Du kannst eine kurze Nachricht hinterlassen oder überspringen und das Fenster schließen.',
		feedbackSkippedText: 'Kein Text angegeben (Übersprungen)',
		messageActionsLabel: 'Nachrichtenaktionen',
		tooltipLike: 'Gefällt mir',
		tooltipDislike: 'Verbesserung',
		tooltipListen: 'Anhören',
		listenToMessage: 'Nachricht anhören',
		speakLoading: 'Stimme wird geladen...',
		speakStop: 'Wiedergabe stoppen',
		speakError:
			'Beim Abspielen der Stimme ist etwas schiefgelaufen. Bitte versuche es erneut.',
		galleryClose: 'Schließen',
		galleryPrev: 'Zurück',
		galleryNext: 'Weiter',
		galleryError: 'Fehler beim Laden des Bildes',
		hide: 'Ausblenden',
		showChatList: 'Chatliste anzeigen',
		hideChatList: 'Chatliste ausblenden',
		showProfilePanel: 'Profilbereich anzeigen',
		hideProfilePanel: 'Profilbereich ausblenden',
		more: 'Mehr',
		imagesCount: 'Bilder & Videos ({count})',
		imagesLabel: 'Bilder',
		noImagesYet: 'In diesem Gespräch wurden noch keine Bilder generiert.',
		imagePlaceholder: 'Der nächste Moment landet hier',
		archiveConversation: 'Gespräch mit {name} archivieren',
		deleteConversationTitle: 'Gespräch löschen?',
		deleteConversationWarning:
			'Diese Aktion kann nicht rückgängig gemacht werden.',
		deleteConversationDeleting: 'Wird gelöscht...',
		deleteConversationDeleted: 'Gelöscht',
		deleteConversation: 'Gespräch löschen',
		no: 'Nein',
		yes: 'Ja',
		newChat: 'Neuer Chat',
		search: 'Suchen',
		searchPlaceholder: 'Gespräche suchen...',
		loadingConversations: 'Gespräche werden geladen',
		noConversationsYet: 'Noch keine Gespräche.',
		profileInfoAria: 'Profilinformationen für {name}',
		thinking: 'Denkt nach',
		typing: 'Schreibt',
		processingMessage: 'Nachricht wird verarbeitet...',
		cancelRecording: 'Abbrechen',
		noDescription: 'Keine ausführliche Beschreibung für dieses Profil.',
		newChatModalTitle: 'Wähle deinen Wunschpartner!',
		newChatModalLoading: 'Partner werden geladen',
		newChatModalNoPersons: 'Keine Partner verfügbar.',
	},

	audioError: {
		title: 'Mikrofonproblem',
		subtitle:
			'Kein Zugriff auf das Mikrofon. Prüfe die Geräteverbindung und Browser-Berechtigungen.',
		deniedSubtitle:
			'Mikrofonzugriff wurde blockiert. Erlaube das Mikrofon für diese Seite in den Browser-Einstellungen.',
		notFoundSubtitle:
			'Kein Mikrofon erkannt. Schließe ein Audiogerät an oder prüfe die Systemeinstellungen.',
		inUseSubtitle:
			'Das Mikrofon wird von einer anderen App verwendet. Schließe sie und versuche es erneut.',
		unsupportedSubtitle:
			'Dein Browser unterstützt Sprachaufnahmen in dieser App nicht.',
		timeoutSubtitle:
			'Zeitüberschreitung beim Mikrofonzugriff. Prüfe die Berechtigungen und versuche es erneut.',
		unknownSubtitle:
			'Ein unerwartetes Mikrofonproblem ist aufgetreten. Prüfe Gerät und Berechtigungen.',
		mimeTypeUnsupportedSubtitle:
			'Dein Browser unterstützt keine Audioaufnahmen. Bitte versuche es mit Chrome, Safari oder Firefox.',
		checkPerms: 'So erlaubst du das Mikrofon:',
		guides: {
			chrome: 'Google Chrome',
			safari: 'Safari',
			mac: 'macOS',
			iphone: 'iPhone / iPad',
		},
		or: 'oder',
		mobileCta: 'Du kannst auch die mobile App nutzen:',
		android: 'Android',
		ios: 'iOS',
		retry: 'Seite aktualisieren',
		tipRefresh:
			'Nach dem Ändern der Berechtigungen aktualisiere die Seite und starte den Anruf erneut.',
	},

	currency: { symbol: '€', code: 'eur' },
	promoPlan: {
		name: 'PREMIUM',
		title: '6 Monate',
		discount: '80%',
		prev: '149.99',
		current: '29.99',
		daily: '0.17',
		popular: true,
		type: 'PREMIUM',
	},
	plans: [
		{
			name: 'PREMIUM',
			title: '6 Monate',
			discount: '70%',
			prev: '149.99',
			current: '44.99',
			daily: '0.25',
			popular: true,
			type: 'PREMIUM',
		},
		{
			name: 'PRO',
			title: '3 Monate',
			discount: '60%',
			prev: '74.99',
			current: '29.99',
			daily: '0.33',
			popular: false,
			type: 'PRO',
		},
		{
			name: 'BASIC',
			title: '1 Monat',
			discount: '40%',
			prev: '24.99',
			current: '14.99',
			daily: '0.50',
			popular: false,
			type: 'BASE',
		},
	],
};
